<div class="home-container home-chooser">
    <section class="path-chooser-hero" aria-labelledby="path-chooser-title">
        <h1 id="path-chooser-title">Spectyra</h1>
        <p class="path-lead">
            Choose how you run Spectyra: next to <strong>OpenClaw</strong> with the Local Companion, or inside <strong>your own product</strong> with the npm SDK.
        </p>

        <div class="path-cards" role="navigation" aria-label="Product paths">
            <a routerLink="/openclaw" class="path-card path-card-openclaw">
                <h2>OpenClaw &amp; Local Companion</h2>
                <p>ClawHub skill, <code class="path-inline-code">spectyra/*</code> model aliases, and the real-time savings dashboard on your machine.</p>
                <span class="path-card-cta">OpenClaw setup →</span>
            </a>
            <a routerLink="/in-app" class="path-card path-card-sdk">
                <h2>In-app integration</h2>
                <p>Install <code class="path-inline-code">&#64;spectyra/sdk</code> and wrap your provider calls—built for application backends and services.</p>
                <span class="path-card-cta">Developer docs →</span>
            </a>
        </div>
    </section>

    <footer class="path-footer">
        <a routerLink="/contact">Contact</a>
        <span class="path-footer-sep" aria-hidden="true">·</span>
        <a routerLink="/login">Sign in</a>
    </footer>
</div>
